import * as R from 'ramda';
import S from 'common/service/sanctuary';
import { of } from 'rxjs';
import { Actions as FarceActions } from 'farce';
import { ofType } from 'redux-observable';
import { startWith, catchError, mergeMap } from 'rxjs/operators';
import { addNotification, replaceNotification } from 'common/mdc/notifications/actions';
import {
  TYPE_SUCCESS, TYPE_ERROR, TYPE_PENDING,
} from 'common/mdc/notifications/notification';
import { PublicError } from 'common/service/error';
import { createErrorStream } from 'common/store/error';

import { load } from '../jobs/actions';

import {
  PURGE,
  clearSelected,
} from '../jobs/actions';

import {
  actions,
  selectors,
} from '../job';


import {
  getSelected,
} from '../jobs/selectors';

const messages = {
  title: {
    id: 'job.actions.remove',
    defaultMessage: 'Job remove',
  },
  pending: {
    id: 'job.actions.remove.pending',
    defaultMessage: 'Job {jobId} is being removed',
  },
  success: {
    id: 'job.actions.remove.success',
    defaultMessage: 'Job {jobId} has been cancelling',
  },
  failure: {
    id: 'job.actions.remove.failed',
    defaultMessage: 'Job {jobId} has not been removed',
  },
};

const removeEpiq = (action, state, { jobService, intl }) => action.pipe(
  ofType(PURGE),
  mergeMap((action$) => {
    const {  jobId } = action$;

    const pendingNotification = addNotification({
      autoHide: false,
      type: TYPE_PENDING,
      title: intl.formatMessage(messages.title),
      text: intl.formatMessage(messages.pending, { jobId: jobId }),
    });

    const failureMessage = intl.formatMessage(
      messages.failure,
      { jobId: jobId },
    );

    return jobService
      .cancelJob(jobId)
      .pipe(
        mergeMap(() => of(
              FarceActions.push('/jobs'),
              replaceNotification(pendingNotification.notification, {
                type: TYPE_SUCCESS,
                autoHide: true,
                text: intl.formatMessage(messages.success, { jobId: jobId }),
                actions: [],
              }),
              actions.clear(),
              load(),
              clearSelected(),

        )),
        startWith(pendingNotification),
        catchError(createErrorStream(action$,
          err => replaceNotification(pendingNotification.notification, {
            type: TYPE_ERROR,
            autoHide: true,
            text: R.is(PublicError, err) && err.message
              ? err.message
              : failureMessage,
            actions: [],
          }))),
      );
  }),
);

export default removeEpiq;
